import React from 'react';
import classNames from 'classnames';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import PriorityCardList from 'Components/ComponentLibrary/Organisms/PriorityCardList';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import FullyRoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/FullyRoundedButton';
import { useSnackbarContext } from 'Context/SnackbarContext';

const styles = theme => ({
  root: {},
  addOutcomeButton: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  emptyState: {
    padding: theme.spacing(3, 0),
  },
  instructions: {
    marginBottom: theme.spacing(2),
  },
});

const Outcomes = ({
  className,
  classes,
}) => {
  const { resource } = useMetaLayoutContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const hasOutComes = Boolean(resource.attr('outcomes')?.resources().list().length >= 1);
  const { displayErrorMessage } = useSnackbarContext();

  const { loadModalCollectionByLink } = useModalContext();
  const { pageContentResource } = usePageContentContext();

  const handleAddOutcome = () => {
    loadModalCollectionByLink(
      pageContentResource
        .relationship(fr.relationships.facetPlanViewAddOutcome.name)
        .link('related')
        .url(),
    );
  };

  return (
    <Box className={classNames(classes.root, className)}>
      {hasOutComes ? (
        <>
          <Typography
            className={classes.instructions}
            color="primaryGray"
          >
            Prioritize outcomes from most important at the top to least important at the bottom.
          </Typography>
          <PriorityCardList
            items={resource.attr('outcomes')?.resources().list() || []}
            refetchItems={() => {
              try {
                refreshPageContentCollection();
              } catch (e) {
                displayErrorMessage(e, 'Failed to change priority');
              }
            }}
          />
        </>) : (
          <Box>
            <Box className={classes.emptyState}>
              <Typography
                align={'center'}
                variant={'h5'}
                color={'primary'}
                weight={'bold'}
              >
                {'No Outcomes'}
              </Typography>
              <Typography
                align={'center'}
                variant={'h6'}
                color={'primary'}
                weight={'book'}
              >
                {'Once created, they will appear here.'}
              </Typography>
            </Box>
            {pageContentResource
              .relationship(fr.relationships.facetPlanViewAddOutcome.name)
              ? (
                <FullyRoundedButton
                  className={classes.addOutcomeButton}
                  fullWidth
                  onClick={handleAddOutcome}
                  test={'facet-plan-view-left-add-outcome-button'}
                >
                  <AddIcon fontSize={'inherit'} />
                  {'Add Outcome'}
                </FullyRoundedButton>
              ) : null}
          </Box>
      )}
    </Box>
  );
};

Outcomes.defaultProps = {
  className: '',
};

Outcomes.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Outcomes);
